import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

const configured = Boolean(url && key);

if (!configured) {
  console.error(
    "[supabase] Missing env vars. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in Cloudflare Pages → Settings → Environment variables (Production AND Preview), then redeploy. Locally, copy .env.example to .env.local and fill in values.",
  );
}

// Pass placeholder values when env vars are missing so createClient doesn't
// throw at module load. The App component checks isConfigured() and renders
// a clear configuration error screen instead — much better than blank white.
export const supabase = createClient(
  url || "https://placeholder.supabase.co",
  key || "placeholder-anon-key",
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);

export function isConfigured() {
  return configured;
}
